/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_FailedInputs */

const en_us2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't rename it right now. Try again.`)
};

const pt_br2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para renomear agora. Tente de novo.`)
};

const es_419_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo renombrar ahora. Inténtalo de nuevo.`)
};

const pt_pt2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível mudar o nome agora. Tenta de novo.`)
};

const fr_fr2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de renommer pour l'instant. Réessaie.`)
};

const de_de2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umbenennen geht gerade nicht. Versuch es erneut.`)
};

const it_it2_coach_manage_rename_failed = /** @type {(inputs: Coach_Manage_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile rinominarla ora. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't rename it right now. Try again." |
*
* @param {Coach_Manage_Rename_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_failed = /** @type {((inputs?: Coach_Manage_Rename_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_failed(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_failed(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_failed(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_failed(inputs)
	return en_us2_coach_manage_rename_failed(inputs)
});
export { coach_manage_rename_failed as "coach-manage.rename_failed" }